import { createAction, props } from '@ngrx/store';

export const uploadAvatarImage = createAction(
  '[User] Upload avatar image',
  props<{ file: File }>(),
);
export const uploadAvatarImageSuccess = createAction(
  '[User] Upload avatar image success',
  props<{ url: string }>(),
);
export const uploadAvatarImageFail = createAction(
  '[User] Upload avatar image fail',
  props<{ error: string }>(),
);
